import React, { useState, useRef, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { ChevronDown } from 'react-bootstrap-icons'

const OneNavLinkDropdown = (props) => {
    const [isOpen, setIsOpen] = useState(false)
    const dropdownRef = useRef(null)
    const location = useLocation()
    const { pathname } = location
    const splitLocation = pathname.split('/')
    const pageName = '/' + splitLocation[1]

    const handleArrowClick = () => {
        setIsOpen(!isOpen)
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            handleArrowClick()
        } else if (e.key === 'Escape' && isOpen) {
            setIsOpen(false)
        }
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    return (
        <div
            ref={dropdownRef}
            className="fw-400 fs-header-link px-md-2 px-lg-3 mx-lg-1 pb-4 pb-md-0 right-menu position-relative"
        >
            <div className="d-flex align-items-center">
                <Link
                    to={props.Link}
                    className={`text-decoration-none text-hover-ss-primary ${
                        pageName === props.Link ? 'text-ss-primary text-hover-ss-primary' : 'text-white'
                    }`}
                >
                    {props.NavItem}
                </Link>
                <div
                    onClick={handleArrowClick}
                    onKeyDown={handleKeyDown}
                    role="button"
                    tabIndex={0}
                    aria-expanded={isOpen}
                    aria-haspopup="true"
                    style={{
                        cursor: 'pointer',
                        color: 'white',
                        marginLeft: '4px',
                        userSelect: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        transition: 'transform 0.2s ease-in-out',
                        transform: isOpen ? 'rotate(180deg)' : 'rotate(0)',
                    }}
                >
                    <ChevronDown size={17} />
                </div>
            </div>
            <div
                className={`dropdown-menu fs-ss-links w-content mt-2 position-absolute ${isOpen ? 'show' : ''}`}
                style={{
                    top: '100%',
                    left: '0',
                    backgroundColor: 'white',
                    borderRadius: '4px',
                    boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                    opacity: isOpen ? 1 : 0,
                    visibility: isOpen ? 'visible' : 'hidden',
                    transform: isOpen ? 'translateY(0)' : 'translateY(-10px)',
                    transition: 'opacity 0.2s ease-in-out, transform 0.2s ease-in-out, visibility 0.2s ease-in-out',
                    minWidth: '200px',
                    whiteSpace: 'nowrap',
                }}
            >
                {React.Children.map(props.DropdownMenu, (child, index) => {
                    if (index > 0) {
                        return (
                            <>
                                <div className="dropdown-divider" style={{ margin: '0.5rem 0' }}></div>
                                {child}
                            </>
                        )
                    }
                    return child
                })}
            </div>
        </div>
    )
}

export default OneNavLinkDropdown
